import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Select, TextField, InputLabel, FormControl, OutlinedInput } from '@material-ui/core';

import GhaDock from '../../../../../models/GhaDock';
import DriverInfoModel from '../../../../../models/GhaManualEntryDriverInfo';

import style from '../manualEntryStyle.module.css';
import commonStyles from '../../../../common/common.module.css';
import { DelivererType } from '../../../../../models/DelivererType.enum';

const styles = (theme: Theme) =>

  createStyles({
    submitBtn: { 
      margin: '10px 20px'
    },
    input: {
      padding: '6px 12px',
      color: 'var(--primaryblue)',
      fontSize: '13px'
    },
    blue: {
      color: 'var(--primaryblue)',
      zIndex: 0,
    },
    selectLabel: {
      color: 'var(--primaryblue)',
      fontSize: '14px'
    },
    shrinkLabel: {
      backgroundColor: 'white',
      padding: '0px 5px'
    },
    select: {
      '& [class^="MuiSelect-select-"]': {
        color: 'var(--primaryblue)',
        fontSize: '13px'
      }
    },
  });
  
interface DriverComponentProps {
  classes: any;
  driverInfo: DriverInfoModel;
  selectedDock: number | null;
  delivererType: string;
  docks: Array<GhaDock>;
  handleChange: (type: string, event: any) => void;
  errors: DriverInfoModel;
  onClick: (event: any) => void;
  maskon: () => void;
  disabled: boolean;
};

const driverComponent = (props: DriverComponentProps) => {
  const rfsDisabled: boolean = props.delivererType === DelivererType.RFS ? false : true;
  const { classes } = props;
  const dockOptions: Array<JSX.Element> = props.docks.map((dock: GhaDock, index: number) => (
    <option key={index} value={dock.id}>
      {dock.name}
    </option>
  ));
  const setTimeWithSeparator = (time: string): string => {
    if (time.length > 5) {
      return time.substring(0, 5);
    }

    if (time.length > 2 && time.indexOf(':') < 0) {
      return time.substring(0, 2) + ':' + time.substring(2, 4);
    }

    return time;
  };

  return (
    <div className={ [commonStyles.wrapper,style.wrapper, style.driverInputsWrapper].join(' ') }>
      <h3 className={ `${ commonStyles.header }` }>Trucker details</h3>
      <div className={ style.inputsWrapper }>
        <div className={ style.driverInfoWrapper }>
          <div className={ style.driverInfoWrapperFirstRow }>
            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Driver's ID<span className={ style.asterisk }>*</span></label>
              <TextField
                required
                id='driverId'
                value={ props.driverInfo.maskedDriverId }
                onChange={ (event) => props.handleChange('driverId', event)}
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                disabled={ props.disabled }
                error={ props.errors.driverId !== '' }
                helperText={ props.errors.driverId !== '' ? props.errors.driverId + ` Driver's ID` : '' }
                onClick={ props.onClick }
                onBlur={ props.maskon }
              />
            </div>

            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Driver's ID Type<span className={ style.asterisk }>*</span></label>
              <TextField
                id='driverIdType'
                value={ props.driverInfo.driverIdType }
                onChange={ (event) => props.handleChange('driverIdType', event) }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                disabled={ props.disabled }
                onClick={ props.onClick }
              />
            </div>

            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Drivers Name <span className={ style.asterisk }>*</span></label>
              <TextField
                required
                id='driverName'
                value={ props.driverInfo.driverName }
                onChange={ (event) => props.handleChange('driverName', event) }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                error={ props.errors.driverName !== '' }
                helperText={ props.errors.driverName !== '' ? props.errors.driverName + ' Drivers Name' : '' }
                onClick={ props.onClick }
                disabled={ props.disabled }
              />
            </div>

            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Truck Plate Number</label>
              <TextField
                id='truckPlateNumber'
                value={ props.driverInfo.truckPlateNumber }
                onChange={ (event) => props.handleChange('truckPlateNumber', event) }
                variant='outlined'
                disabled={ props.disabled }
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                onClick={ props.onClick }
              />
            </div>
            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Trucking Company<span className={ style.asterisk }>*</span></label>
              <TextField
                required
                id='truckingCompany'
                disabled={ props.disabled }
                value={ props.driverInfo.truckingCompany }
                onChange={ (event) => props.handleChange('truckingCompany', event) }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                error={ props.errors.truckingCompany !== '' }
                helperText={ props.errors.truckingCompany !== '' ? props.errors.truckingCompany + ' Trucking Company' : '' }
                onClick={ props.onClick }
              />
            </div>
            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>RFS Number</label>
              <TextField
                required
                disabled={ rfsDisabled || props.disabled }
                id='rfsNumber'
                value={ props.driverInfo.rfsNumber }
                onChange={ (event) => props.handleChange('rfsNumber', event) }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                error={ props.errors.rfsNumber !== '' && !rfsDisabled }
                helperText={ props.errors.rfsNumber !== '' && !rfsDisabled ? props.errors.rfsNumber + ' RFS Number' : '' }
                onClick={ props.onClick }
              />
            </div>
            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }>Arrival Time<span className={ style.asterisk }>*</span></label>
              <TextField
                required
                id='arrivalTime'
                label=''
                disabled={ props.disabled }
                value={ props.driverInfo.arrivalTime }
                onChange={ (event) => props.handleChange('arrivalTime', event) }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                error={ props.errors.arrivalTime !== '' }
                helperText={ props.errors.arrivalTime !== '' ? props.errors.arrivalTime + ' Arrival Time' : '' }
                onClick={ props.onClick }
              />
            </div>
            <div className={ `${ style.textFieldDriver } ${ commonStyles.inputLabelWrapper }` } >
              <label className={ commonStyles.inputLabel }> Enter Dock Number</label>
              <FormControl className={ classes.formControl } variant='outlined'>
                <Select
                  native
                  disabled={ props.disabled }
                  onChange={ (event) => props.handleChange('dockNumber', event) }
                  value={ props.selectedDock ? props.selectedDock : '' }
                  className={ classes.select }
                  input={ <OutlinedInput labelWidth={ 0 }  /> }
                >
                  <option value={-1} />
                  { dockOptions }
                </Select>
              </FormControl>
            </div>   
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(driverComponent);
